import { atom } from '@exodus/headless-ui';
import toAssetAtom from './to-asset.js';
import toWalletAccountAtom from './to-wallet-account.js';
const toAssetRestoringAtom = atom((get, { selectors }) => {
    const toAsset = get(toAssetAtom);
    const restoringAssets = get(selectors.restoringAssets.data);
    return Boolean(restoringAssets[toAsset.baseAsset.name]);
});
const toAssetAddressAtom = atom(async (get, { exodus }) => {
    get(toAssetRestoringAtom);
    const toAsset = get(toAssetAtom);
    const toWalletAccount = get(toWalletAccountAtom);
    try {
        return await exodus.addressProvider.getReceiveAddress({
            assetName: toAsset.name,
            walletAccount: toWalletAccount.toString(),
        });
    }
    catch {
        return null;
    }
});
const toAssetReadyAtom = atom(async (get) => {
    const toAssetAddress = await get(toAssetAddressAtom);
    const toWalletAccount = get(toWalletAccountAtom);
    if (!toWalletAccount.isHardware)
        return true;
    return !!toAssetAddress;
});
export default toAssetReadyAtom;
